<template>
  <div class="pay-on-behalf-of-poster-comp">
    <cache-bust-img class="bg" :src="bgImg" alt="" v-if="bgImg" />

    <div class="wrapper">
      <cache-bust-img class="avatar" :src="info.user_avatar" alt="" />

      <div class="user">
        您的好友 <span class="name">{{ info.user_name }}</span>
        <span class="phone" v-if="info.user_phone">（{{ info.user_phone }}）</span>
      </div>

      <p class="text">邀请您帮TA购买</p>

      <div class="type">天天跳绳<img class="icon" :src="config.icon" alt="" />{{ config.name }}</div>

      <img class="qrcode" :src="qrcodeUrl" alt="" />

      <p class="tips">{{ '长按扫描二维码\n帮好友开通会员' }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ArrayUtil } from 'kuaidong-lib'
import { CacheBustImg } from 'kuaidong-component'
import { IPayOnBehalfOfInfo } from 'kuaidong-model'

import IconSplus from '../images/icon_splus@2x.png'
import IconSSplus from '../images/icon_ssplus@2x.png'

const items = [
  {
    type: 'SPLUS_VIP',
    name: '运动会员',
    icon: IconSplus,
  },
  {
    type: 'SPLUS_PRO',
    name: '运动大会员',
    icon: IconSSplus,
  },
  {
    type: 'SPLUS_PRO_PACKAGE',
    name: '运动大会员',
    icon: IconSSplus,
  },
]

const itemMap = ArrayUtil.buildMapByKey(items, 'type')

const props = defineProps<{ info: IPayOnBehalfOfInfo; bgImg?: string; qrcodeUrl: string }>()

const config = computed(() => itemMap[props.info.product_sn || ''])
</script>

<style lang="less">
.pay-on-behalf-of-poster-comp {
  position: relative;
  width: 300px;
  height: 418px;
  text-align: center;
  background: linear-gradient(180deg, #fe35e4 0%, #ff8dd2 25.13%, #faffe0 52.19%, #ffe240 100%);
  box-sizing: border-box;

  > .bg {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 100%;
  }

  > .wrapper {
    position: absolute;
    top: 0;
    left: 0;
    padding: 136px 0 0 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    > .avatar {
      display: block;
      margin: 0 auto;
      width: 42px;
      height: 42px;
      object-fit: contain;
      border: 1px solid #fff;
      border-radius: 50%;
    }

    > .user {
      margin: 10px 0 0 0;
      white-space: nowrap;
      line-height: 17px;
      font-size: 12px;
      font-size: 500;
      color: #2d2f33;
    }

    > .text,
    > .type {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 4px 0 0 0;
      line-height: 22px;
      font-size: 16px;
      font-weight: 600;
      color: #000;

      > .icon {
        margin: 0 2px;
        width: 21px;
        height: 14px;
        object-fit: contain;
      }
    }

    > .qrcode {
      display: block;
      margin: 30px auto 0 auto;
      width: 80px;
      height: 80px;
      border: 2px solid #fff;
      border-radius: 5px;
    }

    > .tips {
      margin: 6px 0 0 0;
      white-space: pre-line;
      line-height: 17px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.6);
      transform: scale(9 / 12);
      transform-origin: top center;
    }
  }
}
</style>
